<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About The Author</h1>
<p>Cavan Collins was born in 1952 in North Wales in the village of Gwersyllt on the outskirts of Wrexham. His formative years were spent in Solihull in the West Midlands. He describes his childhood as a wonderful time spent safely with his six brothers. He was educated at Lyndon High School and at the age of 17, he began his career as an accountant which continues to the present day. Cavan has five children and four grandchildren. During the nineties, Cavan entered a new phase in his life moving to the beautiful city of Lichfield in Staffordshire, and it was here that he began to write. His poems remained private for many years until early in 2018 when he asked a friend (who just happened to have the most wonderful Welsh accent) if she would read aloud one of his poems to a small group of people. The positive response caused Cavan to reveal the extent of his extraordinary repertoire and gain the confidence to produce his first book of poems.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?deef999c